import { useState } from 'react';

import EmptyIcon from '@/assets/icons/empty.svg';
import { columns } from '@/constants/tableColumns/RequirementControlColumns';
import { columns as employeeColumns } from '@/constants/tableColumns/RequirementControlEmployeeColumns';
import { EmployeeWithRequirementControl } from '@/types/RequirementControl';
import { cn } from '@/utils/cn';

import Table from './Table';

interface RequirementControlCardProps {
	employeeWithRequirementControls: EmployeeWithRequirementControl;
}
const RequirementControlCard = ({
	employeeWithRequirementControls,
}: RequirementControlCardProps) => {
	const [isOpen, setIsOpen] = useState(false);

	const handleToggleCard = () => {
		setIsOpen((prev) => !prev);
	};
	return (
		<div className="relative flex min-w-full flex-col items-start justify-center rounded-lg">
			<div className="absolute left-[430px] z-[100] h-full w-1 bg-background"></div>
			{/* <div className="flex min-h-16 w-full items-center justify-start gap-2"> */}
			<div
				className={cn(
					'flex min-h-16 flex-col items-end justify-start rounded-lg bg-white text-xs text-gray-600',
					isOpen ? 'rounded-b-none' : '',
				)}
			>
				<div className="flex w-full items-center justify-start">
					<div className="min-h-2 w-full px-4">
						<Table
							columns={employeeColumns(isOpen, handleToggleCard)}
							data={[
								{
									...employeeWithRequirementControls.employee,
									requirementControlsCount:
										employeeWithRequirementControls.requirementControls.length,
									situation:
										employeeWithRequirementControls.requirementControls.some(
											(el) => el.situation === 'Irregular',
										)
											? 'Irregular'
											: 'Regular',
								},
							]}
							showHeader={false}
							isWhiteTable={true}
							tBodyClassname="border-none"
							trBodyClassname="border-none flex items-center justify-center h-16 rounded-lg"
							tdHeaderClassname="bg-transparent text-blue-800"
							trHeaderClassname="bg-transparent my-4 rounded-md"
							containerClassname="border-separate border-spacing-y-4"
						/>
					</div>
				</div>
				{isOpen &&
					(employeeWithRequirementControls.requirementControls.length > 0 ? (
						<div className="custom-scrollbar flex h-full w-[82.5%] flex-col items-center justify-end gap-2 overflow-y-scroll bg-white px-4 py-2">
							<Table
								columns={columns}
								data={employeeWithRequirementControls.requirementControls.map(
									(control) => {
										const requirement = {
											id: control.id,
											status: control.status,
											council: control.council,
											recordNumber: control.recordNumber,
											emissionDate: control.emissionDate,
											expirationDate: control.expirationDate,
											situation: control.situation,
											requirement: control.requirement.requirement,
											requirementType: control.requirement.requirementType,
											required: control.requirement.required,
										};
										return requirement;
									},
								)}
								isWhiteTable={true}
								tBodyClassname="border-none"
								trBodyClassname="border-none"
								tdHeaderClassname="bg-transparent"
								trHeaderClassname="bg-transparent my-4 rounded-md"
								tdClassname="px-0 align-top bg-background border-b-8 border-white"
								containerClassname="border-separate border-spacing-y-4 w-full"
							/>
						</div>
					) : (
						<div className="flex min-h-40 w-full flex-col items-center justify-center rounded-b-md rounded-t-none bg-white pb-2">
							<img
								src={EmptyIcon}
								className="w-32"
								alt="Ícone de lista vazia"
							/>
							<div className="w-full text-center text-xs">
								<span className="font-semibold text-blue-800">
									Nenhum requisito cadastrado para esse colaborador!
								</span>
							</div>
						</div>
					))}
			</div>
		</div>
	);
};
export default RequirementControlCard;
